import { Filter as TechnologyFilter, useGetTechnologies } from '@/hooks/useTechnology';
import { useQueryAssets } from '@/hooks/useAssets';
import { useGetRisks } from '@/hooks/useRisks';
import { StorageKey, useStorage } from '@/utils/storage/useStorage.util';

/**
 * Prefetch data for the primary table pages (Assets, Vulnerabilities, Technologies).
 *
 * Call this hook on the Insights page so that when the user navigates to any
 * table, the TanStack Query cache is already warm and data renders instantly.
 *
 * Each hook reads persisted filters from localStorage, producing the exact same
 * query keys the real table pages will use — guaranteeing cache hits.
 */
export function useTablePrefetch() {
  // Assets — reads its own filters from localStorage internally
  useQueryAssets();

  // Vulnerabilities — reads its own filters from localStorage internally
  useGetRisks({ enabled: true, parentFilters: undefined });

  // Technologies — needs filter passed in (matching what the tech page does)
  const [filter] = useStorage<TechnologyFilter>(
    {
      queryKey: 'technologyFilters',
      key: StorageKey.FILTERS_TECHNOLOGIES,
    },
    {
      sort: {
        orderBy: 'name',
        descending: true,
      },
    }
  );
  useGetTechnologies({ filter });
}
